import styled from "@emotion/styled";
import { Icon } from "@trustpilot/businessapp-patternlibrary";
import { checkmark_16 as checkMark } from "@trustpilot/icons";

interface StyledIconProps {
  isOpen?: boolean;
}

const StyledIcon = styled.svg<StyledIconProps>({
  height: 16,
  width: 16,
});

const StyledArrowDown = styled(StyledIcon)(
  {
    transition: "transform .15s ease-in",
  },
  ({ isOpen }) => ({
    transform: isOpen ? "rotateZ(0)" : "rotateZ(180deg)",
  }),
);

const StyledCaretDescending = styled(StyledIcon)(
  {
    transition: "transform .15s ease-in",
  },
  ({ isOpen }) => ({
    transform: isOpen ? "rotateZ(180deg)" : "rotateZ(0)",
  }),
);

const ArrowDown = ({ isOpen }) => (
  <StyledArrowDown isOpen={isOpen} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2187 2.48962L1.60121 9.04663L0.841797 8.39602L7.21832 0.95303L13.6011 8.39584L12.842 9.04681L7.2187 2.48962Z"
      fill="#1C1C1C"
    />
  </StyledArrowDown>
);

const CaretDescending = ({ isOpen }) => (
  <StyledCaretDescending isOpen={isOpen}>
    <path fillRule="evenodd" clipRule="evenodd" d="m11 6-3 4-3-4h6Z" />
  </StyledCaretDescending>
);

const Check = () => <Icon content={checkMark} color={"var(--text-action)"} />;

const Profile = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 12.5V0.5H1.5V12.5H0.5V13.5H3.5V12.5H2.5Z" fill="#1C1C1C" />
    <path d="M8.5 6.5V0.5H7.5V6.5H6.5V7.5H7.5V13.5H8.5V7.5H9.5V6.5H8.5Z" fill="#1C1C1C" />
    <path d="M13.5 3V13.5H14.5V3H15.5V2H14.5V0.5H13.5V2H12.5V3H13.5Z" fill="#1C1C1C" />
  </svg>
);

const Domain = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58174 12.4182 3.32251e-05 8 0ZM10.6938 1.53713C10.9108 1.81846 11.109 2.12893 11.2868 2.46026C11.6083 3.05931 11.8762 3.7473 12.0797 4.5H14.0635C13.2991 3.1786 12.1152 2.13026 10.6938 1.53713ZM14.5404 5.5H12.3046C12.4482 6.28863 12.5251 7.12959 12.5251 8C12.5251 8.87041 12.4482 9.71137 12.3046 10.5H14.5404C14.8373 9.7236 15 8.8808 15 8C15 7.1192 14.8373 6.2764 14.5404 5.5ZM14.0635 11.5H12.0797C11.8762 12.2527 11.6083 12.9407 11.2868 13.5397C11.109 13.8711 10.9108 14.1815 10.6938 14.4629C12.1152 13.8697 13.2991 12.8214 14.0635 11.5ZM5.30644 14.463C5.08949 14.1816 4.89127 13.8711 4.71343 13.5397C4.39194 12.9407 4.12399 12.2527 3.92052 11.5H1.93648C2.70092 12.8215 3.88497 13.8699 5.30644 14.463ZM1.45963 10.5H3.69558C3.55204 9.71137 3.4751 8.87041 3.4751 8C3.4751 7.12959 3.55204 6.28863 3.69558 5.5H1.45963C1.16268 6.2764 1 7.1192 1 8C1 8.8808 1.16268 9.7236 1.45963 10.5ZM1.93648 4.5H3.92052C4.12399 3.7473 4.39194 3.05931 4.71343 2.46026C4.89127 2.12888 5.08949 1.81837 5.30644 1.53701C3.88497 2.13012 2.70092 3.17851 1.93648 4.5ZM5.59456 2.93314C5.34807 3.39242 5.13357 3.9195 4.96011 4.5H7.5V1.07535C6.82296 1.27915 6.15075 1.89676 5.59456 2.93314ZM10.4056 2.93314C10.6521 3.39242 10.8666 3.9195 11.0401 4.5H8.5V1.07529C9.1771 1.27903 9.84939 1.89666 10.4056 2.93314ZM8.5 5.5H11.2868C11.4402 6.27426 11.5251 7.11628 11.5251 8C11.5251 8.88372 11.4402 9.72574 11.2868 10.5H8.5V5.5ZM8.5 11.5H11.0401C10.8666 12.0805 10.6521 12.6076 10.4056 13.0669C9.84939 14.1033 9.1771 14.721 8.5 14.9247V11.5ZM7.5 11.5V14.9247C6.82296 14.7209 6.15075 14.1032 5.59456 13.0669C5.34807 12.6076 5.13357 12.0805 4.96011 11.5H7.5ZM7.5 10.5H4.71343C4.56003 9.72574 4.4751 8.88372 4.4751 8C4.4751 7.11628 4.56003 6.27426 4.71343 5.5H7.5V10.5Z"
      fill="#1C1C1C"
    />
  </svg>
);

const Company = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.5 4H2.25V3H7.5V4Z" fill="#1C1C1C" />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.5 10H2.25V9H4.5V10Z" fill="#1C1C1C" />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.5 7H2.25V6H4.5V7Z" fill="#1C1C1C" />
    <path d="M7 7H8V8H7V7Z" fill="#1C1C1C" />
    <path d="M7 9H8V10H7V9Z" fill="#1C1C1C" />
    <path d="M10.25 7H11.25V8H10.25V7Z" fill="#1C1C1C" />
    <path d="M10.25 9H11.25V10H10.25V9Z" fill="#1C1C1C" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12.75 6H5.5V11H12.75V6ZM4.5 5V12H13.75V5H4.5Z" fill="#1C1C1C" />
    <path d="M1.25 1H8.5V5H9.5V0H0.25V12H4.5V11H1.25V1Z" fill="#1C1C1C" />
  </svg>
);

const Lock = () => (
  <StyledIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path d="M3.6,6.25050847 L3.6,6.25050847 L3.6,14.4161582 C3.6,14.0973434 3.35273875,13.8333333 3.04549171,13.8333333 L12.9545083,13.8333333 C12.6438897,13.8333333 12.4,14.0923382 12.4,14.4161582 L12.4,6.25050847 C12.4,6.56932332 12.6472613,6.83333333 12.9545083,6.83333333 L3.04549171,6.83333333 C3.35611033,6.83333333 3.6,6.57432848 3.6,6.25050847 L3.6,6.25050847 L3.6,6.25050847 Z M2.5,6.25050847 C2.5,5.92806154 2.75041807,5.66666667 3.04549171,5.66666667 L12.9545083,5.66666667 C13.255775,5.66666667 13.5,5.92603467 13.5,6.25050847 L13.5,14.4161582 C13.5,14.7386051 13.2495819,15 12.9545083,15 L3.04549171,15 C2.74422496,15 2.5,14.740632 2.5,14.4161582 L2.5,6.25050847 L2.5,6.25050847 Z M5.25,3.91666667 L5.25,6.83333333 L4.15,5.66666667 L11.85,5.66666667 L10.75,6.83333333 L10.75,3.91666667 C10.75,2.95185206 10.010992,2.16666667 9.10273401,2.16666667 L6.89726599,2.16666667 C5.986927,2.16666667 5.25,2.94930739 5.25,3.91666667 L5.25,3.91666667 Z M4.15,3.91666667 C4.15,2.30583615 5.37860217,1 6.89726599,1 L9.10273401,1 C10.6200071,1 11.85,2.30911386 11.85,3.91666667 L11.85,6.83333333 L4.15,6.83333333 L4.15,3.91666667 L4.15,3.91666667 L4.15,3.91666667 Z M8.55,10.7605874 C8.87879075,10.5588653 9.1,10.1818314 9.1,9.75 C9.1,9.10566779 8.60751322,8.58333333 8,8.58333333 C7.39248678,8.58333333 6.9,9.10566779 6.9,9.75 C6.9,10.1818314 7.12120925,10.5588653 7.45,10.7605874 L7.45,12.0833333 L8.55,12.0833333 L8.55,10.7605874 L8.55,10.7605874 Z" />
    </g>
  </StyledIcon>
);

const Burger = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={{ width: "16px", height: "16px" }}
  >
    <g>
      <path d="M4.21327968,11.323185 L19.7867203,11.323185 C20.4567962,11.323185 21,11.850063 21,12.5 C21,13.149937 20.4567962,13.676815 19.7867203,13.676815 L4.21327968,13.676815 C3.54320381,13.676815 3,13.149937 3,12.5 C3,11.850063 3.54320381,11.323185 4.21327968,11.323185 Z M4.21327968,5 L19.7867203,5 C20.4567962,5 21,5.52687802 21,6.17681499 C21,6.82675196 20.4567962,7.35362998 19.7867203,7.35362998 L4.21327968,7.35362998 C3.54320381,7.35362998 3,6.82675196 3,6.17681499 C3,5.52687802 3.54320381,5 4.21327968,5 Z M4.21327968,17.64637 L19.7867203,17.64637 C20.4567962,17.64637 21,18.173248 21,18.823185 C21,19.473122 20.4567962,20 19.7867203,20 L4.21327968,20 C3.54320381,20 3,19.473122 3,18.823185 C3,18.173248 3.54320381,17.64637 4.21327968,17.64637 Z" />
    </g>
  </svg>
);

const CollapsedMenuToggle = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4956 6.19638L13.803 9.50383H4.0625V10.7538H13.8042L10.4956 14.0625L11.3794 14.9464L16.1964 10.1294L11.3794 5.3125L10.4956 6.19638Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10Z"
      fill="white"
    />
  </svg>
);

const ExternalProfile = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0H0V12H12V6H11V11H1V1H6V0Z" fill="#1C1C1C" />
    <path d="M8 1H10.2929L5.64645 5.64645L6.35355 6.35355L11 1.70711V4H12V0H8V1Z" fill="#1C1C1C" />
  </svg>
);

export default {
  ArrowDown,
  Check,
  Profile,
  Domain,
  Company,
  Lock,
  Burger,
  CollapsedMenuToggle,
  CaretDescending,
  ExternalProfile,
};
